import { get, post, put } from "./api"

export async function runPayroll(startDate, endDate) {
  try {
    return await post('admin/runPayroll', { startDate, endDate })
  } catch (error) {
    return { error }
  }
}

export async function listAllCoachUsers(activeOnly = true) {
  try {
    return await get(`admin/coachUsers?activeOnly=${activeOnly}`)
  } catch (error) {
    return { error }
  }
}

export async function getCoachSummary() {
  try {
    return await get('admin/coachUsers?includeDetails=true&activeOnly=true')
  } catch (error) {
    return { error }
  }
}

export async function getUserById(id) {
  try {
    return await get(`admin/getUser/${id}`)
  } catch (error) {
    return { error }
  }
}

export async function getCampsByWeek() {
  try {
    return await post('admin/campsByWeek', {})
  } catch (error) {
    return { error }
  }
}

export async function getClassesByDayOfWeek() {
  try {
    return await post('admin/classesByDayOfWeek', {})
  } catch (error) {
    return { error }
  }
}

export async function removeKidFromProgram(kidId, programId, futureOnly, removeKid) {
  try {
    return await post('remove_kid_from_program', { kidId, programId, futureOnly, removeKid })
  } catch (error) {
    return { error }
  }
}

export async function getProgramRoster(programId) {
  try {
    return await get(`admin/program/${programId}/roster`)
  } catch (error) {
    return { error }
  }
}

export async function searchKids(firstName, lastName) {
  try {
    return await post('admin/kid/search', { firstName, lastName })
  } catch (error) {
    return { error }
  }
}

export async function addKidToProgram(programId, data) {
  try {
    return await post(`admin/program/${programId}/roster/add`, data)
  } catch (error) {
    return { error }
  }
}

export async function updateKid(kidId, data) {
  try {
    return await put(`admin/kid/${kidId}`, data)
  } catch (error) {
    return { error }
  }
}

export async function getProgramSessions(programId) {
  try {
    return await get(`admin/program/${programId}/sessions`)
  } catch (error) {
    return { error }
  }
}

export async function createProgramSessions(programId) {
  try {
    return await post(`program/${programId}/createSessions`, {})
  } catch (error) {
    return { error }
  }
}

export async function createOneOffProgramSession(programId, date) {
  try {
    return await post(`program/${programId}/createOneOffSession`, { date })
  } catch (error) {
    return { error }
  }
}

export async function updateUser(userId, userData) {
  try {
    return await put(`admin/user/${userId}`, { user: userData })
  } catch (error) {
    return { error }
  }
}

export async function generateRosterXlsx(programIds) {
  try {
    return await post('admin/programs/generate-roster-xlsx', { programIds })
  } catch (error) {
    return { error }
  }
}

export async function generateProgramCsv(programIds) {
  try {
    return await post('admin/programs/generate-program-csv', { programIds })
  } catch (error) {
    return { error }
  }
}

export async function generateInvoiceCsv(programIds, statusUpdate) {
  try {
    return await post('admin/programs/generate-invoice-csv', { programIds, statusUpdate })
  } catch (error) {
    return { error }
  }
}

export async function markStaffExported(userIds) {
  try {
    return await post('admin/users/markExported', { userIds })
  } catch (error) {
    return { error }
  }
}

export async function markStaffNotExported(userIds) {
  try {
    return await post('admin/users/clearExported', { userIds })
  } catch (error) {
    return { error }
  }
}

export async function getReturningKidsTrend() {
  try {
    return await post('admin/returningKidsTrend', {})
  } catch (error) {
    return { error }
  }
}

export async function getCohortRetention(startYear, startSeason, org, sport) {
  try {
    return await post('admin/cohortRetention', { startYear, startSeason, org, sport })
  } catch (error) {
    return { error }
  }
}

export async function getProgramRetention(year, season, org, sport, type) {
  try {
    return await post('admin/programRetention', { year, season, org, sport, type })
  } catch (error) {
    return { error }
  }
}

export async function getKidsByIds(kidIds) {
  try {
    return await post('admin/kids/bulk', { kidIds })
  } catch (error) {
    return { error }
  }
}

export async function getKidsWithPrograms(kidIds, year, season) {
  try {
    return await post('admin/kids/withPrograms', { kidIds, year, season })
  } catch (error) {
    return { error }
  }
}
